import { registerPlugin } from '@capacitor/core';
const PlacePicker = registerPlugin('PlacePicker', {
    web: () => import('./web').then(m => new m.PlacePickerWeb()),
});
export * from './definitions';
export { PlacePicker };
//# sourceMappingURL=index.js.map